<template>
	<form action="" class="filter-bar">
		<div class="filter-bar__container filter-bar__container-1">
			<div class="filter-group">
				<label for="" class="filter-group__label">View</label>
				<select v-model="status" class="filter-group__select">
					<option value="">All</option>
					<option value="inprogress">New + In-Progress</option>
					<option value="new">New</option>
					<option value="preflight">Pre-Shipped</option>
					<option value="delivered">Delivered</option>
					<option value="redo">Re-Do</option>
				</select>
			</div>
			<div class="filter-group__spacer"></div>
			<div class="filter-customer">
				<label for="" class="filter-group__label">Customer</label>
				<select v-model="providerList" class="filter-group__select" >
					<option v-for="customer in customerList" v-bind:key="customer.id" v-bind:value="customer.value">{{ customer.text }}</option>
					
				</select>
			</div>
			<div class="filter-group__spacer"></div>
			<div class="filter-group">
				<label for="" class="filter-group__label">By Product</label>
				<select v-model="sku" class="filter-group__select" >
					<option v-for="product in productList" v-bind:key="product.id" v-bind:value="product.value">{{ product.text }}</option>
					
				</select>
			</div>
		</div>
		<div class="filter-bar__container filter-bar__container-2">
			<div class="filter-group">
				<label for="" class="filter-group__label">By Date</label>
				<input
					type="date"
					name=""
					id=""
					class="filter-group__date"
					ref="dateSelector"
					v-model="date"
				/>
			</div>
			<div class="filter-group__spacer"></div>
			<div class="filter-group">
				<label for="" class="filter-group__label">Search By</label>
				<select v-model="keyword_criteria" class="filter-group__select">
					<option value="serial">A Number</option>
					<option value="external_ref">External Ref</option>
					<option value="itemserial">Item Barcode</option>
					<option value="customer_name">Customer Name</option>
					<option value="shipping_country_code">Country Code</option>
					<option value="waybill">WayBill</option>
				</select>
			</div>
			<div class="filter-group__spacer"></div>
			<div class="filter-group">
				<input
					type="text"
					name=""
					class="filter-group__text-input"
					placeholder="Enter Keyword.."
					v-model="keyword"
				/>
			</div>
			<div class="filter-group__spacer"></div>
			<input type="submit" value="Search" class="filter-group__submit" v-on:click="search" />
		</div>
	</form>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
	name: "FilterBar",
	components: {},
	data() {
		return {
		status: '',
		sku: '',
		date: '',
		
		customerList: {},
		productList: {},
		keyword_criteria: '',
		keyword: '',
		providerList: '',
		
		};
	},
	mounted() {
		{
			const zerofiy = num => {
				return (num < 10 ? "0" : "") + num;
			};

			const date = new Date();

			const today = `${date.getFullYear()}-${zerofiy(
				date.getMonth()
			)}-${zerofiy(date.getDate())}`;

			this.$refs.dateSelector.value = today;
			
			this.getTaskList();
			this.getProductList();
		}
	},
	methods: {
		getTaskList() {
			axios.get('https://new.colorwayrb.com/backend/customerlist.php').then(response => {
				this.customerList = response.data;
				console.log(response.data);
				
			});
		},
		getProductList() {
			axios.get('https://new.colorwayrb.com/backend/productlist.php').then(response => {
				this.productList = response.data;
				console.log(response.data);
				
			});
		},
		
		search: function(e) {
			
			e.preventDefault();
			
			let data = {
				provider: this.providerList,
				status: this.status,
				sku: this.sku,
				date: this.date,
				keyword_criteria: this.keyword_criteria,
				keyword: this.keyword,
			}
			
			this.$store.commit('updateFilter', data);
			this.$store.dispatch('getData')
			console.log(data);
			
			
			
		}
	}
});
</script>




<style lang="scss" scoped>
.filter-bar {
	display: flex;
	justify-content: space-between;
	border: 1px solid $border-color;
	background-color: $color7;
	box-shadow: 0 1px 2px $border-color;
	padding: 10px 15px;

	&__container {
		display: flex;
	}
}

.filter-group {
	display: flex;
	justify-content: space-between;
	align-items: center;

	&__spacer {
		width: 22px;
	}

	&__label {
		letter-spacing: 0.4px;
		margin-right: 10px;
		line-height: 16px;
		font-weight: 500;
		font-size: 11px;
	}

	&__date {
		box-shadow: 1px 1px 1px $border-color;
		border-radius: $btn-border-rad;
		text-align: end;
		font-size: 12px;
		height: 22px;
		border: none;

		text-align: center;
		text-align-last: center;

		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			display: none;
		}

		&::-webkit-datetime-edit-text {
			padding: 0 0.2em;
		}
	}

	&__select {
		box-shadow: 1px 1px 1px $border-color;
		border-radius: $btn-border-rad;
		text-align-last: center;
		font-size: 12px;
		border: none;
		width: 130px;
		height: 22px;
	}

	&__text-input {
		box-shadow: 1px 1px 1px $border-color;
		border-radius: $btn-border-rad;
		padding-left: 10px;
		font-size: 10px;
		border: none;
		width: 120px;
		height: 22px;
	}

	&__submit {
		box-shadow: 1px 1px 1px $border-color;
		text-transform: uppercase;
		background-color: $color3;

		letter-spacing: 0.5px;
		line-height: 16px;
		font-weight: 600;
		font-size: 10px;
		color: $color1;
		border: none;

		transition: background-color $btn-transition ease;
		border-radius: $btn-border-rad;
		padding: 0 30px;
		height: 22px;

		&:hover {
			background-color: $color4;
		}
	}
}
</style>